// extracted by mini-css-extract-plugin
export default {"StickyBlock":"ber_a bhr_bj"};